function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.4906 12.0055C51.754 12.0055 53.0598 13.2715 53.0598 15.5853V25.8881H56.6508V15.7817C56.6508 11.1542 53.8433 8.81855 49.8388 8.81855C47.0313 8.81855 44.5502 9.93179 42.8309 12.3984L44.8984 14.5157C46.2043 12.9222 47.5754 12.0055 49.4906 12.0055Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.8801 26.2592C49.2947 26.2592 50.4917 25.9973 51.5146 25.3643V22.7885C50.7746 23.2033 49.7953 23.5089 48.8594 23.5089C47.2054 23.5089 45.8343 22.7885 45.8343 21.3042C45.8343 19.9509 46.9225 19.2742 48.7941 19.2742H51.5146V16.6548H48.4024C44.6808 16.6548 42.2215 18.4884 42.2215 21.4134C42.1997 24.3165 44.6155 26.2592 47.8801 26.2592Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.378 9.18963H61.8088V32H65.378V9.18963Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0674 17.5061C79.0674 12.5075 75.6505 8.79673 70.9713 8.79673C69.3826 8.79673 68.0115 9.23329 66.945 9.84447V13.1187C68.0332 12.4638 69.252 12.0709 70.3619 12.0709C73.3218 12.0709 75.4546 14.3411 75.4546 17.5061C75.4546 20.693 73.2783 22.985 70.3619 22.985C69.252 22.985 68.0332 22.6139 66.945 21.9372V25.2115C68.0332 25.8663 69.3826 26.2592 70.9713 26.2592C75.6287 26.2592 79.0674 22.5048 79.0674 17.5061Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6203 21.9372L38.0646 12.0273V8.79673H36.8894L29.011 17.8772L21.1978 8.79673H19.979V12.0273L28.3798 21.9372H29.6203Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M95.8254 9.18963H81.0696V12.2892H95.8254V9.18963Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.81428 26.2592C11.8612 26.2592 14.364 24.7531 15.8222 22.3738L13.3194 20.4311C12.2094 21.9591 10.8383 22.9413 8.83605 22.9413C5.8109 22.9413 3.61277 20.6712 3.61277 17.4407V10.6739C1.45817 12.0273 0 14.5157 0 17.5061C0 22.4829 3.8957 26.2592 8.81428 26.2592Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5265 18.0518L19.979 13.97V25.8663H23.5265V18.0518Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3194 14.6467L15.8222 12.6821C14.4075 10.3465 11.97 8.79673 8.81428 8.79673C7.46494 8.79673 6.15912 9.14598 5.17975 9.69168V13.2278C6.15912 12.573 7.44317 12.1146 8.81428 12.1146C10.8165 12.1146 12.2094 13.0969 13.3194 14.6467Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M123.639 9.18963H120.092V20.7804L123.639 17.2005V9.18963Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M131.453 25.8663H135V14.3192L131.453 17.8554V25.8663Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M135 11.9618V8.79673H133.781L120.092 23.116V26.2592H121.311L135 11.9618Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0646 13.97L34.5172 18.0518V25.8663H38.0646V13.97Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M90.2321 13.839H86.6629V25.8663H90.2321V13.839Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M107.295 9.51705C105.88 9.51705 104.727 9.88813 103.66 10.543V14.0791C104.553 13.3588 105.728 12.8131 107.121 12.8131C109.907 12.8131 112.148 14.8868 112.148 18.0082V24.3602C114.39 23.0723 115.804 20.6494 115.804 17.7899C115.804 13.1623 112.126 9.51705 107.295 9.51705Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M107.034 26.2592C108.383 26.2592 109.602 25.9536 110.603 25.3643V21.8718C109.754 22.4829 108.492 22.985 107.143 22.985C104.335 22.985 102.115 20.9113 102.115 17.8117V11.5252C99.9823 12.7476 98.4806 15.1924 98.4806 18.0955C98.4806 22.5703 102.115 26.2592 107.034 26.2592Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M109.515 4.4311L114.129 3.14325L113.345 0L108.622 1.26603C102.899 2.83765 99.5035 5.54434 98.6112 11.4379L102.812 9.73533C103.704 6.72306 106.011 5.47885 109.515 4.4311Z",
  fill: "black"
});

var SvgSmartbeLogo = function SvgSmartbeLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 32,
    viewBox: "0 0 135 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmartbeLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smartbe_logo.d11f0d3e.svg";
export { ForwardRef as ReactComponent };